<div class="sms-builder row">
  <mat-card class="col col-xs-12 col-md-6" style="border-top-right-radius: 0; border-bottom-right-radius: 0">
    <mat-card-header class="sms-header">
      <mat-card-title class="sms-title">{{ 'SMS_BUILDER.SMS_CONFIGURATION' | translate }}</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <sms-builder-form
        [allowDynamic]="allowDynamic"
        [setTextLimit]="setTextLimit"
        [setInitialInputText]="initialInputText"
        (template)="updateSMS($event)"
        (valid)="updateValid($event)"
      ></sms-builder-form>
      <ng-content select="[sms-builder-fields]"></ng-content>
    </mat-card-content>
  </mat-card>
  <mat-card
    class="col col-xs-12 col-md-6"
    style="border-bottom-left-radius: 0; border-top-left-radius: 0; border-left: 0"
  >
    <mat-card-header class="sms-header">
      <mat-card-title class="sms-title">{{ 'SMS_BUILDER.PREVIEW' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <sms-builder-preview
        [allowDynamic]="allowDynamic"
        [messageText]="(sms$ | async).message"
        [smsLink$]="smsLink$"
        [businessName$]="businessName$"
        [messageImageURL$]="messageImageURL$"
      ></sms-builder-preview>
    </mat-card-content>
  </mat-card>
</div>
